import React, { useState } from "react"
import CustomLink from "./CustomLink"
import { setNonDispalyValue } from "./EventHandler"
import { Button, Modal, ModalDialog } from "react-bootstrap"
import { LegendData } from "../../constant/Constants"
import Draggable from "react-draggable"
import * as FileSaver from "file-saver"
import ExcelJS from "exceljs"

const CustomPCTable = (props) => {
   let data = []
   data = props.data

   let keyName = props.keyName ? props.keyName : "Other"

   let excelData = []
   excelData = props.excelData

   let partName = ''
   partName = props.Name


   const [show, setShow] = useState(false)
   const handleClose = () => setShow(false)
   const handleShow = () => setShow(true)


   const getHeader = () => {
      var keys = getKeys()
      return keys.map((key, index) => {
         if (setNonDispalyValue(key)) {
            return null
         }
         return (
            <th key={key}>
               <span>
                  {key}
               </span>
            </th>
         )
      })
   }

   const getRowsData = () => {
      var items = data
      var keys = getKeys()
      return items.map((row, index) => {
         return (
            <tr key={index}>
               <RenderRow key={index} data={row} keys={keys} />
            </tr>
         )
      })
   }

   const getKeys = function () {
      return Object.keys(data[0])
   }

   const getColumnKeys = function (columKeyInfo) {
      return Object.keys(columKeyInfo)
   }

   const getPCLinks = function (data, link, id) {
      var elements = data.map((value, index) => {
         var num = index + 1
         if (
            link[index] &&
            link[index].trim() !== "" &&
            id[index] &&
            id[index].trim() !== "" &&
            id[index].toLowerCase().trim() !== "no access"
         ) {
            return (
               <span key={index}>
                  <CustomLink
                     id={id[index].trim()}
                     link={link[index].trim()}
                     name={value}
                  />
                  {num === data.length ? "" : "|"}
               </span>
            )
         } else {
            return (
               <span key={index}>
                  {value}
                  {num === data.length ? "" : "|"}
               </span>
            )
         }
      })
      return elements
   }

   const RenderColumn = function (props) {
   return props.keys.map((key, index) => {
      if (props.data[key] != null) {
         if (setNonDispalyValue(key)) {
            return null
         } else if (
            key.toLowerCase().trim() === "p" &&
            props.data["id"] &&
            props.data["id"].toLowerCase().trim() !== "no access"
         ) {
            let name = props.data[key]

            return (
               <div key={index} style={{ minWidth: "9rem" }}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                  <span>
                     {props.data["link"] ? (
                        <CustomLink
                           id={props.data["id"]}
                           link={props.data["link"]}
                           name={name}
                        />
                     ) : (
                        <span>{name}</span>
                     )}
                  </span>
               </div>
            )
         } else if (key.toLowerCase() === "name") {
            let nameData = props.data[key] ? props.data[key].split("|") : []
            let nameLink = props.data["methodLink"]
               ? props.data["methodLink"].split("|")
               : []
            let nameId = props.data["methodId"]
               ? props.data["methodId"].split("|")
               : []
            let getnamelinks = getPCLinks(nameData, nameLink, nameId)
            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                  {getnamelinks}
               </div>
            )
         } else if (
            typeof props.data[key] == "object" &&
            key &&
            key.toLowerCase() === "cps"
         ) {
            let names = props.data[key]["name"]
               ? props.data[key]["name"].split("|")
               : []
            let links = props.data[key]["link"]
               ? props.data[key]["link"].split("|")
               : []
            let ids = props.data[key]["id"] ? props.data[key]["id"].split("|") : []
            let getLinks = getPCLinks(names, links, ids)
            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                  {getLinks}
               </div>
            )
         } else if (
            key.toLowerCase() === "ref" ||
            key.toLowerCase().includes("tmrdn")
         ) {
            var refData = props.data[key] ? props.data[key].split("|") : []
            var refLink = props.data["refLink"] ? props.data["refLink"].split("|") : []
            var refId = props.data["refId"] ? props.data["refId"].split("|") : []
            var getlinks = getPCLinks(refData, refLink, refId)
            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                  {getlinks}
               </div>
            )
         } else if (props.data[key] != null && key.toLowerCase() === "cmn") {
            var name = props.data[key]["name"]
               ? props.data[key]["name"].split("|")
               : []
            var link = props.data[key]["link"]
               ? props.data[key]["link"].split("|")
               : []
            var id = props.data[key]["id"] ? props.data[key]["id"].split("|") : []
            var getlinks = getPCLinks(name, link, id)
            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                  {getlinks}
               </div>
            )
         }
         const shouldUseSmallFont = ["LSL", "LTGT", "TGT", "UTGT", "USL","LRRL","URRL"].includes(key)

         return (
            <div key={index} style={{ fontSize: shouldUseSmallFont ? "0.8rem" : "1rem" }}>
               <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
               <span className="lineBreak">{props.data[key]}</span>
            </div>
         )
      } else return null
   })
}

   const RenderRow = (props) => {
   var colKeys = []
   return props.keys.map((key, index) => {
      
      if (props.data[key] != null && typeof props.data[key] == "object") {
         
         colKeys = getColumnKeys(props.data[key])
         const WidthValue = ["LSL", "LTGT", "TGT", "UTGT", "USL","LRRL","URRL"]
         const isWidthValue = WidthValue.some(word => key.includes(word))
         return (
            <td 
               key={index}
               style={{
                  width: isWidthValue ? "10vw" : "auto",
                  minWidth: isWidthValue ? "10vw" : "auto"
               }}
            >
               <RenderColumn isbold={true} data={props.data[key]} keys={colKeys} />
            </td>
         )
      } else if (setNonDispalyValue(key)) {
         return null
      } else {
         return (
            <td key={index}>
               {props.data[key]}
            </td>
         )
      }
   })
}

   const splitLegendData = (data) => {
      const entries = Object.entries(data)
      const firstHalf = entries.slice(0, 14)
      const secondHalf = entries.slice(14)

      return {
         firstHalf: Object.fromEntries(firstHalf),
         secondHalf: Object.fromEntries(secondHalf),
      }
   }

   const { firstHalf, secondHalf } = splitLegendData(LegendData)

   const getTableRows = (data) => {
      return Object.entries(data).map(([key, value], index) => (
         <tr key={index}>
            <td>{key}</td>
            <td>{value}</td>
         </tr>
      ))
   }


   return (
      <div className="performanceTableFixHead">
         {data && data.length > 0 && (
            <>
               {excelData && excelData.length > 0 && (
                  <div style={{ textAlign: "right", marginBottom: "10px" }}>
                     <Button
                        style={{ backgroundColor: "#003DAF" }}
                        variant="primary"
                        onClick={async () => {
                           const fileType =
                              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
                           const fileExtension = ".xlsx"
                           const workbook = new ExcelJS.Workbook()
                           const worksheet = workbook.addWorksheet("data")
                           if (excelData.length > 0) {
                              worksheet.columns = Object.keys(excelData[0]).map((key) => ({
                                 header: key,
                                 key,
                              }))
                              excelData.forEach((row) => worksheet.addRow(row))
                           }
                           const buffer = await workbook.xlsx.writeBuffer()
                           const data = new Blob([buffer], { type: fileType })
                           FileSaver.saveAs(data, `Characteristic_${partName}` + fileExtension)
                        }}
                     >
                        Export to Excel
                     </Button>
                  </div>
               )}
               {keyName == "Other" && <div className="actionDetails1" >
                  <span onClick={handleShow}>
                  PC Legend
                  </span>
               </div>}
               <table id="tab-separtor">
                  <Modal
                     show={show}
                     onHide={handleClose}
                     size="lg"
                     style={{ fontFamily: "var(--app-font-family)" }}
                  >
                     <Modal.Header className="legendTableTitle">
                        <Modal.Title>Legend:</Modal.Title>
                     </Modal.Header>
                     <Modal.Body className="legendTableBodyStyle">
                        <div style={{ display: "flex", gap: "20px" }}>
                           <table className="legendTable">
                              <tbody>{getTableRows(firstHalf)}</tbody>
                           </table>
                           {Object.keys(secondHalf).length > 0 && (
                              <table className="legendTable">
                                 <tbody>{getTableRows(secondHalf)}</tbody>
                              </table>
                           )}
                        </div>
                     </Modal.Body>
                     <Modal.Footer>
                        <Button
                           style={{ backgroundColor: "#003DAF" }}
                           variant="primary"
                           onClick={handleClose}
                        >
                           Close
                        </Button>
                     </Modal.Footer>
                  </Modal>
                  <br></br>
                  <tr style={{ backgroundColor: "#eee" }}>{getHeader()}</tr>
                  <tbody>{getRowsData()}</tbody>
               </table>
            </>
         )}
      </div>
   )
}
export default CustomPCTable
